import React, { useState, useEffect } from "react";
import { useSelector } from "types/store";
import { isEnabled } from "utils/featureFlags";
import * as viewReducer from "containers/View/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import Tooltip from "components/Inputs/Tooltip";
import WarningBanner from "containers/WarningBanner/WarningBanner";
import MarkdownTypewriter from "aible/MarkdownTypewriter/MarkdownTypewriter";
import aibleIconSVG from "images/Aible_Badge-Full-Color.svg";
import styles from "./style.module.css";
const NewChatSimpleHeader = ({ messageOverride, aibleSubtitleTextOverride }) => {
    const backgroundColorDarkMode = useSelector((state) => chatGPTReducer.getBackgroundColorDarkMode(state));
    const agentAutonomyView = useSelector((state) => viewReducer.getAgentAutonomyView(state));
    const [delayRenderText, updateDelayRenderText] = useState(false);
    let aibleMessageText = "How can I help you today?";
    let aibleSubtitleText = {
        text: "I will guide you to the best pre-tested agent for your goal based on your question."
    };
    if (isEnabled("agent-autonomy-controls")) {
        if (agentAutonomyView === "HIGH") {
            aibleMessageText = "What can I automatically do for you?";
            aibleSubtitleText = {
                text: "I am an agent that will use the following tools and agents to answer your questions:"
            };
        }
        if (agentAutonomyView === "MODERATE") {
            aibleMessageText = "What agent would you like to build?";
            aibleSubtitleText = undefined;
        }
        if (agentAutonomyView === "LOW") {
            aibleMessageText = "Let's build your agent step by step";
            aibleSubtitleText = undefined;
        }
    }
    if (messageOverride) {
        aibleMessageText = messageOverride;
    }
    if (aibleSubtitleTextOverride) {
        aibleSubtitleText = {
            ...aibleSubtitleTextOverride
        };
    }
    const aibleTextOverride = {
        p: {
            style: {
                fontSize: "24px",
                fontWeight: "bold",
                lineHeight: "1.6"
            }
        }
    };
    useEffect(() => {
        updateDelayRenderText(false);
        const delayTextTimer = setTimeout(() => {
            updateDelayRenderText(true);
        }, 50);
        return () => clearInterval(delayTextTimer);
    }, [agentAutonomyView]);
    let mainBoxStyling = { height: "auto", color: backgroundColorDarkMode ? "#EFECF6" : "#9E9DBC" };
    if (isEnabled("new-chat-top-sample-templates")) {
        mainBoxStyling = {
            ...mainBoxStyling,
            padding: "80px 24px 28px"
        };
    }
    return (React.createElement(React.Fragment, null,
        isEnabled("chat-aible-beta-warning") && React.createElement(WarningBanner, { type: "chat_aible_beta_warning" }),
        React.createElement("div", { className: styles.mainBox, style: mainBoxStyling },
            React.createElement("div", { className: styles.headerWrapperFadeIn, style: { width: "910px" } },
                React.createElement("div", { className: styles.simpleHeaderMain },
                    React.createElement("div", { className: styles.aibleNewChatIcon },
                        React.createElement("img", { src: aibleIconSVG })),
                    React.createElement("div", { className: delayRenderText
                            ? styles.simpleHeaderText + " " + styles.simpleHeaderTextVisible
                            : styles.simpleHeaderText },
                        React.createElement(MarkdownTypewriter, { text: aibleMessageText, textDelay: 40, overrides: aibleTextOverride, chunkSize: 2, startupDelay: 500, replaceText: true }),
                        aibleSubtitleText && aibleSubtitleText?.text && (React.createElement(Tooltip, { trigger: aibleSubtitleText?.tooltip ? ["hover"] : ["none"], placement: "right", overlay: React.createElement("div", { style: aibleSubtitleText?.tooltipStyle }, aibleSubtitleText?.tooltip) },
                            React.createElement("div", { className: delayRenderText
                                    ? styles.simpleHeaderSubtitleText + " " + styles.simpleHeaderSubtitleTextVisible
                                    : styles.simpleHeaderSubtitleText }, aibleSubtitleText.text)))))))));
};
export default NewChatSimpleHeader;
